// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createActions } from 'redux-actions';

export const UPLOAD_SAFETY_ATTACHMENTS = 'UPLOAD_SAFETY_ATTACHMENTS';
export const UPLOAD_SAFETY_ATTACHMENTS_SUCCESS =
    'UPLOAD_SAFETY_ATTACHMENTS_SUCCESS';
export const CLEAR_SAFETY_ATTACHMENT_INFO = 'CLEAR_SAFETY_ATTACHMENT_INFO';
export const {
    uploadSafetyAttachments,
    uploadSafetyAttachmentsSuccess,
    clearSafetyAttachmentInfo,
} = createActions(
    UPLOAD_SAFETY_ATTACHMENTS,
    UPLOAD_SAFETY_ATTACHMENTS_SUCCESS,
    CLEAR_SAFETY_ATTACHMENT_INFO
);
